import React, { useState, useRef } from 'react'
import domtoimage from 'dom-to-image-more'
import {
  Row, Col, Button, Steps, Popover, Tooltip,
} from 'antd'
import Icon, {
  PictureOutlined, UndoOutlined, InfoCircleOutlined, LeftOutlined, RightOutlined,
  SaveOutlined, FolderOpenOutlined,
} from '@ant-design/icons'

import { useScroll } from 'ahooks'
import { GASSIEN_COLOR } from '../../static/colors'


import { formatPrice } from '../../engine/prices'
import track from '../../engine/tracking'


import BoxModal from '../elements/BoxModal'
import CalculatorModal from '../elements/CalculatorModal'

import {
  StyleInfos, WallBasesInfos, BoardsInfos, AccessoriesInfos,
} from './StepsInfos'

import GridSvg from '../svg/grid'
import Hooks from '../svg/hooks'
import Board from '../svg/board'
import Empty from '../svg/empty'

import { useIsSmallDevice } from '../../hookreducer/hooks'


import __ from '../../languages/parser'

const { Step } = Steps


const cropCanvas = (sourceCanvas, left, top, width, height) => {
  const destCanvas = document.createElement('canvas')
  destCanvas.width = width
  destCanvas.height = height
  destCanvas.getContext('2d').drawImage(
    sourceCanvas,
    left, top, width, height, // source rect with content to crop
    0, 0, width, height,
  ) // newCanvas, same size as source rect
  return destCanvas
}

const saveAsPng = (idElement, fileName = 'Gassien-composition') => {
  const scale = 2

  const domNode = document.getElementById(idElement)
  const { offsetLeft, offsetTop } = domNode
  const width = (domNode.clientWidth + offsetLeft * 2) * scale
  const height = (domNode.clientHeight + offsetTop) * scale

  domtoimage.toCanvas(domNode, {
    bgcolor: 'white',
    width,
    height,
    style: {
      transform: `scale(${scale})`,
      transformOrigin: 'top left',
    },
  })
    .then((canvas) => {
      const croppedCanvas = cropCanvas(
        canvas,
        offsetLeft * scale,
        offsetTop * scale,
        domNode.clientWidth * scale,
        domNode.clientHeight * scale,
      )
      const link = document.createElement('a')
      link.download = fileName
      console.log(croppedCanvas)
      link.href = canvas.toDataURL('image/png')
      link.click()
    })
}

const StepTitleSmall = ({ title, content }) => (
  <span className="maker-subtitle-step-small">
    <span>{title}</span>
    <Popover placement="bottom" content={content} title={title} trigger="hover">
      <span style={{ marginLeft: '1em' }}>
        <InfoCircleOutlined />
      </span>
    </Popover>
  </span>
)

const StepTitle = ({ title, content }) => (
  <span className="maker-subtitle-step">
    <span>{title}</span>
    <Popover placement="bottom" content={content} title={title} trigger="hover">
      <span style={{ marginLeft: '1em' }}>
        <InfoCircleOutlined />
      </span>
    </Popover>
  </span>
)

const MakerMenuSmall = ({
  reset,
  setShortkeys,
  setCartVisibility,
  addBox,
  totalPrice,
  currentStep,
  setCurrentStep,
  setShowTuto,
  setModalOpenComposition,
  saveComposition,
  loadingSaveComposition,
}) => {
  const [showCalculatorModal, setShowCalculatorModal] = useState(false)
  const [showBoxModal, setShowBoxModal] = useState(false)

  const ref = useRef(null)

  const { left } = useScroll(ref)


  const maxScroll = ref.current ? ref.current.scrollWidth - ref.current.clientWidth : null

  const scrollLimit = left === 0 ? 'left' : left >= maxScroll - 1 ? 'right' : 'both'

  const SIZE = 'large'

  const styleStep = {
  }

  const setScroll = (direction) => {
    const stepScroll = direction === 'right' ? 100 : -100
    ref.current.scrollLeft += stepScroll
  }

  return (
    <>
      <Row style={{ marginBottom: '10px', fontSize: '0.8em' }}>

        <Col span={4}>
          <Button
            size={SIZE}
            block
            onClick={() => {
              setShowTuto(true)
            }}
          >
            <InfoCircleOutlined />

          </Button>
        </Col>
        <Col span={4}>
          <Button size={SIZE} block onClick={reset}>
            <UndoOutlined />
          </Button>
        </Col>

        <Col span={8}>
          <Button
            size={SIZE}
            block
            onClick={saveComposition}
            disabled={totalPrice === 0}
            loading={loadingSaveComposition}
            icon={<SaveOutlined />}
          >
            {__('Save')}
          </Button>
        </Col>

        <Col span={8}>
          <Button
            size={SIZE}
            block
            onClick={() => {
              setModalOpenComposition(true)
            }}
            icon={<FolderOpenOutlined />}
          >
            {__('Open')}
          </Button>
        </Col>


      </Row>
      <Row>
        <Col
          span={12}
          style={{
            textAlign: 'center',
          }}
        >
          <span style={{ fontSize: '1em', lineHeight: '40px' }} className="configuration-price">
            {totalPrice ? `${formatPrice(totalPrice)}` : '- €'}
          </span>
        </Col>

        <Col span={12} style={{ textAlign: 'right' }}>
          <Button
            type="primary"
            size={SIZE}
            style={{ width: '100%' }}
            onClick={() => { setCartVisibility(true) }}
            disabled={totalPrice === 0}
          >
            {__('Details')}
          </Button>
        </Col>
      </Row>

      <Row style={{ marginTop: '8px', height: '52px' }}>
        <Col span={1} style={{ fontSize: '0.8em', color: '#AAAAAA', lineHeight: '32px' }}>
          {scrollLimit === 'left' ? null
            : (
              <Button
                block
                type="text"
                size="small"
                style={{
                  padding: 0, margin: 0, border: 'none', backgroundColor: 'none',
                }}
                onClick={() => setScroll('left')}
              >
                <LeftOutlined />
              </Button>
            )}

        </Col>

        <Col offset={1} span={20}>

          <div
            style={{
              overflowX: 'scroll',
              overflowY: 'hidden',
              paddingBottom: '12px',
            }}
            ref={ref}
          >

            <Steps
              current={currentStep}
              onChange={(cur) => setCurrentStep(cur)}
              className="site-navigation-steps-small"
              style={{
                fontSize: '1.2em',
                flexDirection: 'row',
                minHeight: '32px',
              }}
              direction="vertical"
            >
              <Step
                title={<StepTitleSmall title={__('Style')} content={<StyleInfos />} />}
                icon={<Icon component={Empty} />}
                className="step-without-icon"
                style={styleStep}
              />
              <Step
                title={<StepTitleSmall title={__('Wall bases')} content={<WallBasesInfos />} />}
                icon={<Icon component={GridSvg} />}
                style={styleStep}

              />
              <Step
                title={<StepTitleSmall title={__('Boards')} content={<BoardsInfos />} />}
                icon={<Icon component={Board} />}
                style={styleStep}

              />
              <Step
                title={<StepTitleSmall title={__('Accessories')} content={<AccessoriesInfos />} />}
                icon={<Icon component={Hooks} />}
                style={styleStep}
              />
            </Steps>
          </div>
        </Col>
        <Col offset={1} span={1} style={{ fontSize: '0.8em', color: '#AAAAAA', lineHeight: '32px' }}>
          {scrollLimit === 'right' ? null
            : (
              <Button
                block
                type="text"
                size="small"
                style={{
                  padding: 0, margin: 0, border: 'none', backgroundColor: 'none',
                }}
                onClick={() => setScroll('right')}

              >
                <RightOutlined />
              </Button>
            )}


        </Col>

      </Row>

      <BoxModal
        show={showBoxModal}
        addBox={(dim) => { addBox(dim); setShowBoxModal(false); setShortkeys(true) }}
        cancel={() => { setShowBoxModal(false); setShortkeys(true) }}
      />

      <CalculatorModal
        show={showCalculatorModal}
        handleClose={() => setShowCalculatorModal(false)}
      />
    </>
  )
}

const MakerMenu = ({
  reset,
  // setTitle,
  title,
  setShortkeys,
  setCartVisibility,
  addBox,
  selectElement,
  totalPrice,
  currentStep,
  setCurrentStep,
  setShowTuto,
  setModalOpenComposition,
  saveComposition,
  loadingSaveComposition,
}) => {
  const pngFileName = title ? `GASSIEN Paris - ${title}.png` : __('GASSIEN Paris - my composition.png')

  const [showCalculatorModal, setShowCalculatorModal] = useState(false)
  const [showBoxModal, setShowBoxModal] = useState(false)
  const SIZE = 'default'

  return (
    <>
      <Row style={{ marginBottom: '1em' }}>
        <Col span={3}>
          <h1>{__('Configurator')}</h1>
        </Col>
        <Col span={1}>
          <Button type="link" size={SIZE} block onClick={() => setShowTuto(true)}>
            <InfoCircleOutlined />
          </Button>
        </Col>
        <Col span={8}>
          <Row>
            <Col
              offset={2}
              span={10}
              style={{
                textAlign: 'right',
                paddingRight: '1em',
              }}
            >
              <span className="configuration-price">
                {totalPrice ? `TOTAL : ${formatPrice(totalPrice)}` : '- €'}
              </span>
            </Col>
            <Col span={12} style={{ textAlign: 'right' }}>
              <Button
                type="primary"
                shape="round"
                style={{ width: '100%' }}
                onClick={() => { setCartVisibility(true) }}
                disabled={totalPrice === 0}
              >
                {__('Details')}
              </Button>
            </Col>

          </Row>
        </Col>
        <Col offset={1} span={11}>
          <Row>
            <Col span={7}>
              <Button
                size={SIZE}
                block
                onClick={() => { track('spaceDimensions'); setShortkeys(false); setShowBoxModal(true) }}
              >
                {__('Space dimensions')}
              </Button>
            </Col>


            <Col offset={1} span={5}>
              <Tooltip placement="bottom" title={__('Save composition')} color={GASSIEN_COLOR}>
                <Button
                  size={SIZE}
                  block
                  onClick={saveComposition}
                  disabled={totalPrice === 0}
                  loading={loadingSaveComposition}
                  icon={<SaveOutlined />}
                >
                  {__('Save')}
                </Button>
              </Tooltip>
            </Col>

            <Col span={5}>
              <Tooltip placement="bottom" title={__('Open composition')} color={GASSIEN_COLOR}>
                <Button
                  size={SIZE}
                  block
                  onClick={() => {
                    setModalOpenComposition(true)
                  }}
                >
                  <FolderOpenOutlined />
                  {__('Open')}
                </Button>
              </Tooltip>
            </Col>

            <Col offset={1} span={2}>
              <Tooltip placement="bottom" title={__('Download image')} color={GASSIEN_COLOR}>
                <Button
                  size={SIZE}
                  block
                  onClick={() => {
                    selectElement(null)
                    saveAsPng('whiteboard', pngFileName)
                  }}
                >
                  <PictureOutlined />
                </Button>
              </Tooltip>
            </Col>
            <Col span={2}>
              <Tooltip placement="bottomLeft" title={__('Reset')} color={GASSIEN_COLOR}>
                <Button size={SIZE} block onClick={reset}>
                  <UndoOutlined />
                </Button>
              </Tooltip>

            </Col>

          </Row>
        </Col>

      </Row>

      <Row style={{ marginBottom: '20px', padding: '0 5%', fontSize: '1em' }}>
        <Steps
          current={currentStep}
          onChange={(cur) => setCurrentStep(cur)}
          className="site-navigation-steps"
          style={{ fontSize: '1em' }}
        >
          <Step
            title={<StepTitle title={__('Style')} content={<StyleInfos />} />}
            icon={<Icon component={Empty} />}
          />
          <Step
            title={<StepTitle title={__('Wall bases')} content={<WallBasesInfos />} />}
            icon={<Icon component={GridSvg} />}
          />
          <Step
            title={<StepTitle title={__('Boards')} content={<BoardsInfos />} />}
            icon={<Icon component={Board} />}
          />
          <Step
            title={<StepTitle title={__('Accessories')} content={<AccessoriesInfos />} />}
            icon={<Icon component={Hooks} />}
          />
        </Steps>
      </Row>

      <BoxModal
        show={showBoxModal}
        addBox={(dim) => { addBox(dim); setShowBoxModal(false); setShortkeys(true) }}
        cancel={() => { setShowBoxModal(false); setShortkeys(true) }}
      />

      <CalculatorModal
        show={showCalculatorModal}
        handleClose={() => setShowCalculatorModal(false)}
      />
    </>
  )
}

const MakerContainer = (props) => {
  const isSmall = useIsSmallDevice()
  return isSmall ? <MakerMenuSmall {...props} /> : <MakerMenu {...props} />
}


export default MakerContainer
